import { handleActions } from "redux-actions";
import { setCreatedDefaultConverters } from "../actions/actions";

export default handleActions(
  {
    [setCreatedDefaultConverters]: (state, action) => {
      return action.payload;
    },
  },
  {}
);
